import React, { createContext, useContext, useState } from "react";
import { useCuestionario } from "../hooks/useCuestionario";
import { useUser } from "../hooks/useUser";
import { GeneralContext } from "./GeneralContext";
import { useTranslation } from "react-i18next";

export const ResultadoContext = createContext();

export function ResultadoContextProvider(props) {
    const { t } = useTranslation()
    const { cuestionarioID, chartImage } = useContext(GeneralContext);
  const { user } = useUser();
  const { getCuestionarioReport } = useCuestionario();
  //Loading boton PDF
  const [loading, setLoading] = React.useState(null);

  function GetCuestionarioReport() {
    var reportPromise = getCuestionarioReport(user, cuestionarioID, chartImage);
    reportPromise.then(
      (x) => {
        let blob = new Blob([x], { type: "application/pdf" });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
            link.download = t("Report.nombreInformeFinal");
        link.click();
        setLoading(null)
      },
      (y) => {
        console.error("Error: " + y);
      }
    );
  }

  return (
    <ResultadoContext.Provider value={{GetCuestionarioReport, loading, setLoading}}>
      {props.children}
    </ResultadoContext.Provider>
  );
}
